import { gql } from '@apollo/client';

export const GET_BAKER_USERS = gql`
  query GetBakerUsers {
    bakerUsers {
      email
      profile
      inventory
      loans
      lseg
      dailyPricing
      reports
      portfolios
      cashFlows
      swapIQ
      houstonTrust
      empyreanImport
      yieldBookMonitor
    }
  }
`;
